const test = (state, data) => {
  // console.log(data);
}

export default {
  test,
}
